import Image from 'next/image';
import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, PyronStrategy, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const PyronTriggerDetails = ({ trigger, triggerType }: Props) => {
  const assetAddress = useMemo(() => {
    return trigger.context?.asset || '';
  }, [trigger.context]);

  const strategyLabel = useMemo(() => {
    const strategy = trigger.context?.strategy;
    return strategy === PyronStrategy.Lend ? 'Lending' : strategy === PyronStrategy.Borrow ? 'Borrowing' : '';
  }, [trigger.context]);

  const scannerUrl = useMemo(() => {
    if (!assetAddress) return '';
    return `https://explorer.solana.com/address/${assetAddress}`;
  }, [assetAddress]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Asset"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/solana.webp" width={12} height={12} alt="Solana" />
            <span>{maskAddressValue(assetAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />

      <TriggerValueDetail label="Strategy" value={strategyLabel} />
    </div>
  );
};
